var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 styled-scrollbar-custom",
      attrs: { id: "annonce-create-step-right-part" }
    },
    [
      !_vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "col-12 pl-0 pr-0 mb-1",
              attrs: { id: "annonce-create-step-right-part-inside" }
            },
            [
              _c(
                "transition-group",
                {
                  staticClass: "item-container-annonce",
                  attrs: { name: "listCustomTransition", tag: "div" }
                },
                _vm._l(_vm.annonces, function(annonce, index) {
                  return _c(
                    "div",
                    {
                      key: index + "-annonce",
                      staticClass: "item-annonce",
                      on: {
                        click: function($event) {
                          return _vm.editAnnonce($event, index)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                annonce.brand.name + " - " + annonce.model.name
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "ph ph-custom ph-trash main-red-color cursor-pointer editAnnonce-forbidden",
                            on: {
                              click: function($event) {
                                return _vm.removeAnnonce(index)
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      annonce.vehicleFiles.length > 0
                        ? _c("div", [
                            _c("img", {
                              staticClass: "w-100 rounded",
                              attrs: {
                                src:
                                  annonce.vehicleFiles[0].url ||
                                  annonce.vehicleFiles[0].safeUrl ||
                                  annonce.vehicleFiles[0].fileUrl,
                                alt: "Annonce Image"
                              }
                            })
                          ])
                        : _c("div", [
                            _c("img", {
                              staticClass: "w-100 rounded no-result-img",
                              attrs: {
                                src: require("@/assets/images/b122/PLACEHOLDER.png"),
                                alt: "no result"
                              }
                            })
                          ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between mt-2" },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c("i", {
                                staticClass:
                                  "ph ph-custom ph-scan main-color cursor-pointer"
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "ml-2" }, [
                                _vm._v(_vm._s(_vm.formatAnnonceInfo(annonce)))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            _vm._l(5, function(index) {
                              return _c("i", {
                                class:
                                  (index <= annonce.additionnalRewardLevel.value
                                    ? "ph-star-fill"
                                    : "ph-star") + " main-color"
                              })
                            }),
                            0
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mt-2" },
                        [
                          _c("i", {
                            staticClass:
                              "ph ph-custom ph-map-pin main-color cursor-pointer"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "ml-2" }, [
                            _vm._v(_vm._s(annonce.address.value))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mt-2" },
                        [
                          _c(
                            "div",
                            {
                              class:
                                "ml-2 " +
                                (annonce.isComplete
                                  ? "main-green-color"
                                  : "main-red-color")
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  annonce.isComplete
                                    ? _vm.$t("create.annonce.summary.complete")
                                    : _vm.$t("create.annonce.summary.partial")
                                )
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.annoncesSaved.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "small-text",
                      class: { "mt-3": this.annonces.length > 0 }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("annonce.Recap.annonces.saved")) +
                          "\n    "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.annoncesSaved, function(annonce, index) {
                return _c("div", { key: index, staticClass: "item-annonce" }, [
                  _c("div", { staticClass: "d-flex justify-content-between" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(annonce.brand.name + " - " + annonce.model.name)
                      )
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass:
                        "ph ph-custom ph-trash main-red-color cursor-pointer"
                    })
                  ]),
                  _vm._v(" "),
                  annonce.vehicleFiles.length > 0
                    ? _c("div", [
                        _c("img", {
                          staticClass: "w-100 rounded",
                          attrs: {
                            src:
                              annonce.vehicleFiles[0].url ||
                              annonce.vehicleFiles[0].safeUrl ||
                              annonce.vehicleFiles[0].fileUrl,
                            alt: "Annonce Image"
                          }
                        })
                      ])
                    : _c("div", [
                        _c("img", {
                          staticClass: "w-100 rounded no-result-img",
                          attrs: {
                            src: require("@/assets/images/b122/PLACEHOLDER.png"),
                            alt: "no result"
                          }
                        })
                      ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-between mt-2" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mr-1" },
                        [
                          _c("i", {
                            staticClass:
                              "ph ph-custom ph-scan main-color cursor-pointer"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "ml-2" }, [
                            _vm._v(_vm._s(_vm.formatAnnonceInfo(annonce)))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        _vm._l(5, function(index) {
                          return _c("i", {
                            class:
                              (index <= annonce.additionnalRewardLevel
                                ? "ph-star-fill"
                                : "ph-star") + " main-color"
                          })
                        }),
                        0
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex align-items-center mt-2" }, [
                    _c("i", {
                      staticClass:
                        "ph ph-custom ph-map-pin main-color cursor-pointer"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-2" }, [
                      _vm._v(_vm._s(annonce.address.value))
                    ])
                  ])
                ])
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex justify-content-center",
                  class: {
                    "mt-3":
                      this.annonces.length + this.annoncesSaved.length > 0,
                    "pb-4": this.annonces.length + this.annoncesSaved.length > 1
                  }
                },
                [
                  _c("i", {
                    staticClass:
                      "ph ph-custom ph-plus-circle custom-plus main-color cursor-pointer",
                    on: {
                      click: function($event) {
                        return _vm.$bvModal.show("recap-add-annonce")
                      }
                    }
                  })
                ]
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("recap-add-annonce", {
        on: {
          addNewAnnonce: _vm.addNewAnnonce,
          openBrouillonModal: _vm.openBrouillonModal
        }
      }),
      _vm._v(" "),
      _c("recap-add-brouillon-annonce-modal", {
        attrs: { annoncesIds: _vm.annoncesIds },
        on: {
          addDraft: _vm.addDraft,
          openRecapAddAnnonceModal: _vm.backToAddAnnonce
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46185c36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46185c36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/annonce/AnnonceCreate/AnnonceCreateRecapStep.vue
// module id = scN/
// module chunks = 0